/* SingRank - ABLINK "Level up your fleet" planner (2026-10-16).
   Everything runs in the browser and lives only in memory: nothing typed here is stored,
   put in a URL or sent to analytics. Unknown values stay "To be confirmed" - never S$0. */
(function () {
  'use strict';

  var TBC = 'To be confirmed';
  var MAX_SLOTS = 3;
  var WA_MAX_URL = 1900;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function slug(s) {
    return String(s || '').toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9.]/g, ''); }
  function money(n) {
    if (n == null || !isFinite(n)) return TBC;
    var neg = n < 0;
    var s = 'S$' + Math.round(Math.abs(n)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return neg ? '-' + s : s;
  }
  function num(v) {
    if (v == null) return null;
    var s = String(v).replace(/[^0-9.\-]/g, '');
    if (s === '' || s === '-' || s === '.') return null;
    var n = Number(s);
    return isFinite(n) ? n : null;
  }
  function fmtNum(n, dp) {
    if (n == null || !isFinite(n)) return '';
    var f = dp == null ? Math.round(n * 100) / 100 : Number(n.toFixed(dp));
    return String(f).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function dateText(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return String(iso);
    return d.toLocaleDateString('en-SG', { day: 'numeric', month: 'short', year: 'numeric' });
  }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* analytics never breaks the page */ }
  }

  function Planner(root) {
    this.root = root;
    var cfgEl = $(root, '[data-llf-config]');
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { this.cfg = {}; }
    this.cfg.whatsapp = String(this.cfg.whatsapp || '').replace(/[^0-9]/g, '');
    this.blockByName = {};
    var self = this;
    (this.cfg.chargers || []).forEach(function (b) { if (b && b.name) self.blockByName[norm(b.name)] = b; });
    this.evs = [];
    this.byId = {};
    this.chargersByModel = {};
    this.allChargers = [];
    this.asOf = '';
    this.started = false;
    this.reset(true);
    this.bind();
    this.bindPrint();
    this.load();
  }

  Planner.prototype.reset = function (silent) {
    this.s = {
      charging: '', daily_km: null, park_h: null, ex_model: '', ex_type: '', ex_kw: null,
      charger: null, assessment: false,
      slots: [], chosen: null, chosenRemovedMsg: false, finder: false, cmpOpen: false,
      trade: '', ti_reg: '', ti_model: '', ti_value: null, ti_settle: null, ti_value_unknown: false, ti_settle_unknown: false
    };
    this.errors = {};
    if (silent) return;
    $$(this.root, 'input[type=radio], input[type=checkbox]').forEach(function (i) { i.checked = false; });
    $$(this.root, 'input[type=number], input[type=text], input[type=search]').forEach(function (i) { i.value = ''; i.disabled = false; i.removeAttribute('aria-invalid'); });
    $$(this.root, 'select').forEach(function (s) { s.selectedIndex = 0; });
    $$(this.root, '[data-err]').forEach(function (e) { e.hidden = true; });
    this.renderAll();
    this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ---------- data ---------- */
  Planner.prototype.load = function () {
    var self = this;
    var errBox = $(this.root, '[data-load-error]');
    errBox.hidden = true;
    var direct = $(this.root, '[data-wa-direct]');
    if (direct) direct.href = this.waUrl('Hi ABLINK, I would like help planning a switch to electric vehicles.');
    var base = String(this.cfg.compareApi || '').replace(/\/+$/, '');
    var cars = String(this.cfg.carsApi || '').replace(/\/+$/, '');
    var pCat = fetch(base + '/compare/catalog?condition=all', { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('catalog ' + r.status);
      return r.json();
    });
    var pCars = fetch(cars + '/cars', { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    // ABLINK's charger price list (Compare API /planner/chargers, read from the CHARGER PRICELIST sheet tab).
    // Optional: while it does not exist the page falls back to the price list in the vehicle feed.
    var listUrl = String(this.cfg.chargerListApi || (base ? base + '/planner/chargers' : '')).trim();
    var pList = listUrl ? fetch(listUrl, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }) : Promise.resolve(null);
    Promise.all([pCat, pCars, pList]).then(function (res) {
      self.applyPricelist(res[2]);
      self.ingest(res[0], res[1]);
      self.renderAll();
    }).catch(function () {
      errBox.hidden = false;
      self.evs = [];
      self.renderAll();
    });
  };

  Planner.prototype.ingest = function (cat, carsBody) {
    var self = this;
    var rows = (cat && cat.vehicles) || [];
    this.asOf = (cat && cat.generated_at) || '';
    this.evs = rows.filter(function (r) { return String(r.fuel_type || '').toUpperCase() === 'ELECTRIC'; });
    this.byId = {};
    this.evs.forEach(function (r) { self.byId[r.id] = r; });
    var cars = (carsBody && (carsBody.data || carsBody.cars)) || [];
    this.chargersByModel = {};
    var all = {};
    cars.forEach(function (c) {
      var list = (c.ev_chargers || []).filter(function (x) { return x && x.name; }).map(function (x) { return self.makeCharger(x); });
      list = list.filter(function (x) { return x.active; });
      if (list.length) self.chargersByModel[slug(c.make_model)] = list;
      list.forEach(function (x) {
        var k = x.key;
        if (!all[k]) all[k] = Object.assign({}, x, { minPrice: x.price, maxPrice: x.price });
        else {
          if (x.price != null) {
            all[k].minPrice = all[k].minPrice == null ? x.price : Math.min(all[k].minPrice, x.price);
            all[k].maxPrice = all[k].maxPrice == null ? x.price : Math.max(all[k].maxPrice, x.price);
          }
          if (!all[k].time && x.time) all[k].time = x.time;
        }
      });
    });
    // chargers in ABLINK's price list that no vehicle lists yet: offered, but "To be checked" per EV
    Object.keys(this.listByName || {}).forEach(function (k) {
      if (all[k]) return;
      var r = self.listByName[k];
      var c = self.makeCharger({ name: r.name, type: r.type, power_kw: r.power_kw });
      if (c.active) all[k] = Object.assign({}, c, { minPrice: c.price, maxPrice: c.price });
    });
    this.allChargers = Object.keys(all).map(function (k) { return all[k]; }).sort(function (a, b) {
      return (a.type === b.type ? 0 : a.type === 'AC' ? -1 : 1) || ((a.kw || 0) - (b.kw || 0));
    });
    this.heroPhoto();
    // keep only shortlist items that still exist
    this.s.slots = this.s.slots.filter(function (id) { return self.byId[id]; });
    if (this.s.chosen && !this.byId[this.s.chosen]) this.s.chosen = null;
    var catSel = $(this.root, '[data-cat]');
    var cats = {};
    this.evs.forEach(function (r) { if (r.category) cats[r.category] = 1; });
    catSel.innerHTML = '<option value="">All electric vehicles</option>' + Object.keys(cats).sort().map(function (c) {
      return '<option value="' + esc(c) + '">' + esc(c.charAt(0) + c.slice(1).toLowerCase()) + '</option>';
    }).join('');
  };

  /* Header slider: ABLINK's own EV photos from the vehicle list (vans first, one photo per model).
     A photo chosen in the theme editor is shown alone instead. Swipe / dots / auto-advance (paused on hover,
     focus, touch, hidden tab, and off for visitors who prefer reduced motion). */
  Planner.prototype.heroPhoto = function () {
    var box = $(this.root, '[data-hero-media]');
    var track = box && $(box, '[data-slides]');
    if (!track || this.heroBuilt) return;
    this.heroBuilt = true;
    if (!track.children.length) {
      var seen = {}, list = [];
      this.evs.forEach(function (r) {
        if (!r.photo || seen[r.photo] || seen[r.make_model]) return;
        seen[r.photo] = seen[r.make_model] = 1;
        list.push(r);
      });
      function isVan(r) { return /van/i.test((r.category || '') + ' ' + (r.make_model || '')) ? 1 : 0; }
      list.sort(function (a, b) { return isVan(b) - isVan(a); });
      list = list.slice(0, 6);
      if (!list.length) return;
      track.innerHTML = list.map(function (r, i) {
        return '<figure class="llf-slide" aria-roledescription="slide" aria-label="' + (i + 1) + ' of ' + list.length + '">' +
          '<img src="' + esc(r.photo) + '" alt="' + esc(r.make_model) + '" decoding="async"' + (i ? ' loading="lazy"' : ' fetchpriority="high"') + '>' +
          '<figcaption>' + esc(r.make_model) + '</figcaption></figure>';
      }).join('');
    }
    box.hidden = false;
    var slides = $$(track, '.llf-slide');
    var dots = $(box, '[data-dots]');
    if (slides.length < 2) { dots.hidden = true; return; }
    dots.innerHTML = slides.map(function (x, i) { return '<button type="button" aria-label="Show photo ' + (i + 1) + '" data-dot="' + i + '"></button>'; }).join('');
    var cur = 0, timer = null, paused = false, st = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function mark(i) { cur = i; $$(dots, 'button').forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); mark(i); }
    function tick() { if (!paused && !document.hidden) go((cur + 1) % slides.length); }
    function restart() { clearInterval(timer); if (!reduce) timer = setInterval(tick, 4500); }
    mark(0);
    dots.addEventListener('click', function (e) { var d = e.target.closest('[data-dot]'); if (d) { go(+d.getAttribute('data-dot')); restart(); } });
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== cur && slides[i]) mark(i); }, 80);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go((cur + 1) % slides.length); restart(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go((cur - 1 + slides.length) % slides.length); restart(); }
    });
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { box.addEventListener(ev, function () { paused = true; }, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { box.addEventListener(ev, function () { paused = false; }); });
    box.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 6000); }, { passive: true });
    restart();
  };

  /* Charger price list from ABLINK (sheet via the Compare API). One source per field:
     price list  > theme-editor charger block > vehicle feed. Missing numbers stay null (To be confirmed). */
  Planner.prototype.applyPricelist = function (body) {
    this.listByName = {};
    this.listOnly = [];
    this.listUpdated = '';
    var rows = body && Array.isArray(body.chargers) ? body.chargers : [];
    var self = this;
    this.listUpdated = (body && body.updated_at) || '';
    rows.forEach(function (r) {
      if (!r || !r.name) return;
      self.listByName[norm(r.name)] = r;
    });
  };

  Planner.prototype.makeCharger = function (x) {
    var key = norm(x.name);
    var b = this.blockByName[key] || {};
    var p = (this.listByName || {})[key] || {};
    function pick(a, bb, c) { return a != null && a !== '' ? a : (bb != null && bb !== '' ? bb : c); }
    var feedPrice = num(x.price_value) != null ? num(x.price_value) : num(x.price);
    var listPrice = num(p.hardware_price);
    return {
      key: key,
      name: p.name || x.name,
      type: String(pick(p.type, x.type, /dc/i.test(x.name) ? 'DC' : /ac/i.test(x.name) ? 'AC' : '') || '').toUpperCase(),
      kw: num(pick(p.power_kw, x.power_kw, null)),
      price: listPrice != null ? listPrice : feedPrice,
      priceSource: listPrice != null ? 'ABLINK charger price list' : (feedPrice != null ? 'ABLINK vehicle price list' : ''),
      time: pick(p.charging_time, x.charging_time, ''),
      note: pick(p.note, x.note, ''),
      image: pick(p.image, b.image, x.logo || ''),
      connector: pick(p.connector, b.connector, ''),
      installPrice: num(pick(p.install_price, b.install_price, null)),
      installScope: pick(p.install_scope, b.install_scope, ''),
      installLead: pick(p.install_lead, b.install_lead, ''),
      bundled: p.bundled != null ? !!p.bundled : !!b.bundled,
      active: p.active === false ? false : b.active !== false
    };
  };

  Planner.prototype.ev = function () { return this.s.chosen ? this.byId[this.s.chosen] : null; };
  Planner.prototype.evChargers = function (ev) { return ev ? (this.chargersByModel[ev.model_id || ''] || this.chargersByModel[slug(ev.make_model)] || []) : []; };

  /* charger as it applies to the chosen EV: price + technical compatibility */
  Planner.prototype.resolveCharger = function () {
    var c = this.s.charger;
    if (!c) return null;
    var ev = this.ev();
    var offered = this.evChargers(ev);
    var match = null;
    offered.forEach(function (x) { if (x.key === c.key) match = x; });
    var base = match || c;
    var tech;
    if (!ev) tech = { cls: 'warn', text: 'Choose an EV to check compatibility' };
    else if (match) tech = { cls: 'ok', text: 'Listed by ABLINK for this EV' };
    else tech = { cls: 'warn', text: 'To be checked for this EV' };
    return {
      key: c.key, name: base.name, type: base.type, kw: base.kw, connector: base.connector, image: base.image,
      price: match ? match.price : (c.priceSource === 'ABLINK charger price list' ? c.price : (ev ? null : c.price)), offered: !!match, tech: tech,
      time: match ? match.time : '', installPrice: base.installPrice, installScope: base.installScope,
      installLead: base.installLead, bundled: base.bundled
    };
  };

  /* ---------- events ---------- */
  Planner.prototype.bind = function () {
    var self = this, root = this.root;
    function start() { if (!self.started) { self.started = true; track('planner_start'); } }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'llf-charging') {
        start();
        self.s.charging = t.value;
        if (t.value !== 'yes') self.s.charger = null;
        if (t.value === 'yes' || t.value === 'unsure') self.s.assessment = self.s.assessment && true;
        self.renderAll();
      } else if (t.name === 'llf-trade') {
        start();
        self.s.trade = t.value;
        track('tradein_option_selected', { option: t.value });
        self.renderAll();
      } else if (t.matches('[data-unknown]')) {
        var f = t.getAttribute('data-unknown');
        self.s[f + '_unknown'] = t.checked;
        var inp = $(root, '[data-num="' + f + '"]');
        if (inp) { inp.disabled = t.checked; if (t.checked) { inp.value = ''; self.s[f] = null; self.setErr(f, ''); } }
        self.renderStep3(); self.renderSummary(); self.renderStepStates();
      } else if (t.matches('[data-text]')) {
        self.s[t.getAttribute('data-text')] = t.value.trim();
        self.renderSummary();
      } else if (t.matches('[data-cat]')) {
        self.renderResults();
      }
    });

    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches('[data-num]')) {
        start();
        var f = t.getAttribute('data-num');
        var raw = t.value.trim();
        var v = raw === '' ? null : Number(raw);
        if (raw !== '' && (!isFinite(v) || v < 0)) {
          self.setErr(f, 'Please enter a number of 0 or more.');
          self.s[f] = null;
        } else {
          var max = Number(t.getAttribute('max'));
          if (v != null && max && v > max) { self.setErr(f, 'That looks too high - please check.'); self.s[f] = null; }
          else { self.setErr(f, ''); self.s[f] = v; }
        }
        if (f === 'daily_km' || f === 'park_h') self.renderStep1();
        if (f === 'ti_value' || f === 'ti_settle') self.renderStep3();
        self.renderSummary(); self.renderStepStates();
      } else if (t.matches('[data-text]')) {
        self.s[t.getAttribute('data-text')] = t.value.trim();
      } else if (t.matches('[data-search]')) {
        self.renderResults();
      }
    });

    root.addEventListener('click', function (e) {
      var b = e.target.closest('button, a');
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-retry')) { self.load(); return; }
      if (b.hasAttribute('data-open-chargers')) { self.openChargers(b); return; }
      if (b.hasAttribute('data-pick-charger')) {
        var k = b.getAttribute('data-pick-charger');
        var pool = self.chargerPool();
        var c = null; pool.forEach(function (x) { if (x.key === k) c = x; });
        if (c) {
          self.s.charger = { key: c.key, name: c.name, type: c.type, kw: c.kw, price: c.price, priceSource: c.priceSource, connector: c.connector, image: c.image,
            installPrice: c.installPrice, installScope: c.installScope, installLead: c.installLead, bundled: c.bundled };
          track('charger_selected', { charger: c.key, type: c.type || 'unknown' });
        }
        self.closeDlg(); self.renderAll(); return;
      }
      if (b.hasAttribute('data-clear-charger')) { self.s.charger = null; self.renderAll(); return; }
      if (b.hasAttribute('data-help')) { self.renderHelp(); return; }
      if (b.hasAttribute('data-add')) { self.addEv(b.getAttribute('data-add')); return; }
      if (b.hasAttribute('data-remove')) { self.removeEv(b.getAttribute('data-remove')); return; }
      if (b.hasAttribute('data-use')) {
        self.s.chosen = b.getAttribute('data-use'); self.s.chosenRemovedMsg = false;
        track('ev_selected', { ev_id: self.s.chosen });
        self.renderAll(); return;
      }
      if (b.hasAttribute('data-focus-search')) {
        self.s.finder = true; self.renderResults();
        var q = $(root, '[data-search]');
        if (q) { q.focus({ preventScroll: true }); $(root, '[data-finder]').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        return;
      }
      if (b.hasAttribute('data-finder-close')) { self.s.finder = false; self.renderResults(); $(root, '#llf-s2').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (b.hasAttribute('data-cmp-toggle')) { self.s.cmpOpen = !self.s.cmpOpen; self.renderCompare(); return; }
      if (b.hasAttribute('data-wa')) { self.openWa(b.getAttribute('data-wa')); return; }
      if (b.hasAttribute('data-wa-open')) { track(self.waKind === 'assessment' ? 'site_assessment_whatsapp_click' : 'plan_whatsapp_click', { kind: self.waKind }); return; }
      if (b.hasAttribute('data-copy')) { self.copyPlan(); return; }
      if (b.hasAttribute('data-close')) { self.closeDlg(); return; }
      if (b.hasAttribute('data-print')) { self.print(); return; }
      if (b.hasAttribute('data-reset')) { self.reset(false); return; }
      if (b.hasAttribute('data-fab')) { $(root, '#llf-plan').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    });

    $$(root, '.llf-dlg').forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d) self.closeDlg(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.openDlgEl) self.closeDlg();
      if (e.key === 'Tab' && self.openDlgEl) self.trapFocus(e);
    });

    // compact "View my plan" button: shown once the visitor has started, hidden while the plan is on screen
    var fab = $(root, '[data-fab]');
    var plan = $(root, '#llf-plan');
    var planVisible = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        planVisible = en[0].isIntersecting;
        fab.hidden = planVisible || !self.started;
        if (planVisible && !self.summarySeen && self.started) { self.summarySeen = true; track('plan_summary_view'); }
      }, { threshold: 0.15 }).observe(plan);
    }
    this.updateFab = function () { fab.hidden = planVisible || !self.started; };
  };

  Planner.prototype.setErr = function (f, msg) {
    var el = $(this.root, '[data-err="' + f + '"]');
    var inp = $(this.root, '[data-num="' + f + '"]');
    if (el) { el.textContent = msg; el.hidden = !msg; }
    if (inp) { if (msg) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid'); }
  };

  /* ---------- EV shortlist ---------- */
  Planner.prototype.addEv = function (id) {
    if (!this.byId[id] || this.s.slots.indexOf(id) !== -1) return;
    if (this.s.slots.length >= MAX_SLOTS) return;
    this.s.slots.push(id);
    if (this.s.slots.length >= MAX_SLOTS) this.s.finder = false;
    if (!this.started) { this.started = true; track('planner_start'); }
    track('ev_added', { ev_id: id, count: this.s.slots.length });
    if (this.s.slots.length === 1 && !this.s.chosen) this.s.chosenRemovedMsg = false;
    this.renderAll();
  };
  Planner.prototype.removeEv = function (id) {
    this.s.slots = this.s.slots.filter(function (x) { return x !== id; });
    if (this.s.chosen === id) { this.s.chosen = null; this.s.chosenRemovedMsg = true; }
    this.renderAll();
  };

  /* ---------- rendering ---------- */
  Planner.prototype.renderAll = function () {
    var ex = $(this.root, '[data-existing]');
    if (ex) ex.hidden = this.s.charging !== 'existing';
    var tr = $(this.root, '[data-trade]');
    if (tr) tr.hidden = this.s.trade !== 'yes';
    this.renderStep1();
    this.renderResults();
    this.renderSlots();
    this.renderCompare();
    this.renderStep3();
    this.renderSummary();
    this.renderStepStates();
    if (this.updateFab) this.updateFab();
  };

  Planner.prototype.renderStepStates = function () {
    var s = this.s;
    var st = {
      1: s.charging ? ({ yes: s.charger ? 'Charger chosen' : 'Charging location', existing: 'Existing charger', public: 'Public charging', unsure: 'Assessment pending' }[s.charging]) : '',
      2: s.chosen ? 'EV chosen' : (s.slots.length ? s.slots.length + ' shortlisted' : ''),
      3: s.trade ? ({ yes: 'Trade-in', no: 'No trade-in', unsure: 'Not sure' }[s.trade]) : ''
    };
    var self = this;
    [1, 2, 3].forEach(function (n) {
      var a = $(self.root, '[data-step-link="' + n + '"]');
      var sm = $(self.root, '[data-step-state="' + n + '"]');
      var done = n === 2 ? !!s.chosen : !!st[n];
      if (a) { a.classList.toggle('is-done', done); a.classList.remove('is-current'); }
      if (sm) sm.textContent = st[n] || 'Not started';
    });
    // the first step that is not done yet is highlighted as the current one
    var next = [1, 2, 3].filter(function (n) { return !$(self.root, '[data-step-link="' + n + '"]').classList.contains('is-done'); })[0];
    if (next) $(self.root, '[data-step-link="' + next + '"]').classList.add('is-current');
  };

  var ICON_CHARGER = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h7a2 2 0 0 1 2 2v16H4V5a2 2 0 0 1 2-2Z"/><path d="M7 7h5v4H7z"/><path d="M15 9h1.5A1.5 1.5 0 0 1 18 10.5V16a1.5 1.5 0 0 0 3 0V8l-2-2"/><path d="M2 21h15"/></svg>';
  var ICON_VAN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 16V8a2 2 0 0 1 2-2h11l5 5v5h-2"/><path d="M15 6v5h5"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M9 17h6"/></svg>';
  var ICON_TOOLS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.2L3 17.8V21h3.2l6.3-6.3a4 4 0 0 0 5.2-5.4l-2.6 2.6-2.4-.6-.6-2.4Z"/></svg>';

  Planner.prototype.chargerCardHtml = function (c, on) {
    var img = c.image ? '<img class="llf-ch-img" src="' + esc(c.image) + '" alt="" loading="lazy">' :
      '<span class="llf-ch-img is-empty" aria-hidden="true">' + esc(c.type || 'EV') + '</span>';
    var price;
    if (c.bundled) price = 'Included with the vehicle';
    else if (c.price != null) price = money(c.price);
    else if (c.minPrice != null) price = c.minPrice === c.maxPrice ? money(c.minPrice) : money(c.minPrice) + ' - ' + money(c.maxPrice) + ' (depends on EV)';
    else price = TBC;
    return '<button type="button" class="llf-ch' + (on ? ' is-on' : '') + '" data-pick-charger="' + esc(c.key) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + img +
      '<span><b>' + esc(c.name) + '</b><dl>' +
      '<dt>Type</dt><dd>' + esc(c.type || TBC) + '</dd>' +
      '<dt>Rated</dt><dd>' + (c.kw != null ? esc(fmtNum(c.kw)) + ' kW' : TBC) + '</dd>' +
      '<dt>Connector</dt><dd>' + (c.connector ? esc(c.connector) : '<span class="llf-tbc">' + TBC + '</span>') + '</dd>' +
      '<dt>Hardware</dt><dd>' + esc(price) + '</dd>' +
      '<dt>Installation</dt><dd>' + (c.installPrice != null ? esc(money(c.installPrice)) : '<span class="llf-tbc">' + TBC + '</span>') +
      (c.installScope ? '<br><span class="llf-small">' + esc(c.installScope) + '</span>' : '') + '</dd>' +
      (c.time ? '<dt>Listed time</dt><dd>' + esc(c.time) + '</dd>' : '') +
      '</dl></span></button>';
  };

  Planner.prototype.chargerPool = function () {
    var ev = this.ev();
    var list = this.evChargers(ev);
    return list.length ? list : this.allChargers;
  };

  Planner.prototype.renderStep1 = function () {
    var box = $(this.root, '[data-s1-dyn]');
    var s = this.s, cfg = this.cfg, h = '';
    var assess = '<div class="llf-assess"><h3>Not sure what your site needs?</h3>' +
      '<p class="llf-muted">' + esc(cfg.assessmentCopy || '') + ' A request is not a confirmed booking.</p>' +
      '<div class="llf-row llf-noprint"><button type="button" class="llf-btn is-accent" data-wa="assessment">Request a charger site assessment</button></div></div>';
    if (s.charging === 'yes') {
      var c = this.resolveCharger();
      var pick;
      if (c) {
        pick = '<div class="llf-pick"><div class="llf-pick-img">' + (c.image ? '<img src="' + esc(c.image) + '" alt="' + esc(c.name) + '" loading="lazy">' : ICON_CHARGER) + '</div>' +
          '<div><h3>' + esc(c.name) + '</h3><p class="llf-chosen-meta">' + esc(c.type || '') + (c.kw != null ? ' &middot; ' + esc(fmtNum(c.kw)) + ' kW rated' : '') +
          ' &middot; ' + (c.bundled ? 'Included with the vehicle' : c.price != null ? esc(money(c.price)) + ' hardware' : 'Hardware price ' + TBC) + '</p>' +
          '<div class="llf-row llf-chosen-pills"><span class="llf-pill ' + c.tech.cls + '">Technical: ' + esc(c.tech.text) + '</span>' +
          '<span class="llf-pill warn">Site suitability: needs site assessment</span></div>' +
          '<div class="llf-row llf-noprint"><button type="button" class="llf-btn is-outline is-small" data-open-chargers>Change charger</button>' +
          '<button type="button" class="llf-btn is-link" data-clear-charger>Remove</button></div></div></div>' +
          '<p class="llf-small llf-block">A charger\'s rating alone does not set the actual charging speed - the vehicle\'s own charging limit and the site supply also count. ' + esc(cfg.chargerTaxNote || '') + '</p>';
      } else {
        var sample = this.chargerPool().filter(function (x) { return x.image; })[0];
        pick = '<div class="llf-pick"><div class="llf-pick-img">' + (sample ? '<img src="' + esc(sample.image) + '" alt="" loading="lazy">' : ICON_CHARGER) + '</div>' +
          '<div><h3>Select a charger</h3><p class="llf-muted">Hardware and installation quoted separately.</p>' +
          '<div class="llf-row llf-noprint"><button type="button" class="llf-btn is-outline" data-open-chargers><span aria-hidden="true">+</span> Explore chargers</button>' +
          '<button type="button" class="llf-btn is-link" data-open-chargers data-help-open>Help me choose</button></div></div></div>' +
          '<p class="llf-small llf-block">You can also choose your EV first - charging options and prices then match that vehicle.</p>';
      }
      h += '<div class="llf-panel"><div>' + pick + '</div>' + assess + '</div>';
    } else if (s.charging === 'existing') {
      h += '<div class="llf-row"><span class="llf-pill warn">Compatibility: To be checked</span><span class="llf-pill warn">Site suitability: to be checked</span></div>' +
        '<p class="llf-small llf-block">ABLINK checks your charger against the EV you choose. Until then it is not shown as compatible.</p>';
    } else if (s.charging === 'public') {
      h += '<p class="llf-note">Public charging costs are excluded from this purchase estimate.</p>';
    } else if (s.charging === 'unsure') {
      h += '<div class="llf-panel"><div><div class="llf-row"><span class="llf-pill warn">Charging plan: site assessment pending</span></div>' +
        '<p class="llf-muted" style="margin-top:10px">You can carry on and compare EVs - no charger needs to be chosen first.</p></div>' + assess + '</div>';
    }
    box.innerHTML = h;
  };

  Planner.prototype.openChargers = function (btn) {
    this.lastFocus = btn;
    this.renderChargerDlg(btn && btn.hasAttribute('data-help-open'));
    this.openDlg('chargers');
  };

  Planner.prototype.renderChargerDlg = function (withHelp) {
    var body = $(this.root, '[data-ch-body]');
    var ev = this.ev();
    var pool = this.chargerPool();
    var cur = this.s.charger ? this.s.charger.key : '';
    var self = this;
    var intro = ev ? 'Options ABLINK lists for <b>' + esc(ev.make_model) + '</b>. Prices are from ABLINK\'s price list.' :
      'Options across ABLINK\'s EVs. Choose an EV in step 2 to see the exact price for that vehicle.';
    var html = '<p class="llf-muted">' + intro + '</p>' +
      '<div class="llf-row" style="margin-top:10px"><button type="button" class="llf-btn is-small" data-help>Help me choose</button></div>' +
      '<div data-help-out></div>';
    if (!pool.length) html += '<p class="llf-note llf-block">Charger options could not be loaded right now. ' + TBC + ' - ask ABLINK in the site assessment.</p>';
    else html += '<div class="llf-ch-list">' + pool.map(function (c) { return self.chargerCardHtml(c, c.key === cur); }).join('') + '</div>';
    html += '<p class="llf-small llf-block">' + esc(this.cfg.chargerTaxNote || '') + ' Installation scope is confirmed after a site assessment.</p>';
    body.innerHTML = html;
    if (withHelp) this.renderHelp();
  };

  /* "Help me choose": indicative only, from the visitor's own distance + parking time and the EV's listed consumption */
  Planner.prototype.renderHelp = function () {
    var out = $(this.root, '[data-help-out]');
    if (!out) return;
    var s = this.s, ev = this.ev();
    var cons = ev && ev.consumption && ev.consumption.value != null && ev.consumption.unit === 'kWh/100km' ? ev.consumption.value : null;
    if (s.daily_km == null || s.park_h == null || !s.park_h) {
      out.innerHTML = '<p class="llf-note warn llf-block">Fill in daily distance and overnight parking hours in step 1, then press Help me choose again.</p>';
      return;
    }
    if (cons == null) {
      out.innerHTML = '<p class="llf-note warn llf-block">Choose an EV with a listed energy consumption in step 2 so the energy needed can be estimated.</p>';
      return;
    }
    var kwh = s.daily_km / 100 * cons;
    var pool = this.chargerPool().filter(function (c) { return c.kw; });
    var fit = pool.filter(function (c) { return c.type !== 'DC' && kwh / c.kw <= s.park_h; }).sort(function (a, b) { return a.kw - b.kw; })[0];
    var rows = pool.map(function (c) { return '<li>' + esc(c.name) + ': about ' + esc(fmtNum(kwh / c.kw, 1)) + ' h at full rated power</li>'; }).join('');
    out.innerHTML = '<div class="llf-note llf-block"><b>About ' + esc(fmtNum(kwh, 1)) + ' kWh a day</b> (' + esc(fmtNum(s.daily_km)) + ' km &times; ' + esc(fmtNum(cons, 1)) + ' kWh/100 km listed).' +
      '<ul class="llf-pending">' + rows + '</ul>' +
      (fit ? 'With ' + esc(fmtNum(s.park_h)) + ' h parked overnight, <b>' + esc(fit.name) + '</b> looks like the smallest option that fits.' :
        'None of the AC options fits within ' + esc(fmtNum(s.park_h)) + ' h at rated power - ask ABLINK about faster charging.') +
      '<br><span class="llf-small">Indicative only: real charging is slower when the vehicle\'s onboard limit or the site supply is lower. Confirm at the site assessment.</span></div>';
  };

  Planner.prototype.renderResults = function () {
    var box = $(this.root, '[data-results]');
    var finder = $(this.root, '[data-finder]');
    if (finder) finder.hidden = !this.s.finder;
    if (!this.evs.length) { box.innerHTML = this.s.finder ? '<p class="llf-muted">Loading electric vehicles&hellip;</p>' : ''; return; }
    var q = ($(this.root, '[data-search]').value || '').toLowerCase().trim();
    var cat = $(this.root, '[data-cat]').value;
    var self = this;
    var list = this.evs.filter(function (r) {
      if (cat && r.category !== cat) return false;
      if (!q) return true;
      return (r.make_model + ' ' + (r.variant || '') + ' ' + (r.category || '')).toLowerCase().indexOf(q) !== -1;
    });
    var full = this.s.slots.length >= MAX_SLOTS;
    box.innerHTML = list.length ? list.map(function (r) {
      var inList = self.s.slots.indexOf(r.id) !== -1;
      return '<div class="llf-res">' + (r.photo ? '<img src="' + esc(r.photo) + '" alt="" loading="lazy">' : '') +
        '<div style="min-width:0"><b>' + esc(r.make_model) + '</b><span class="llf-small">' + esc([r.variant, r.condition === 'used' ? 'Used' : 'New', r.price && r.price.display].filter(Boolean).join(' · ')) + '</span></div>' +
        '<button type="button" class="llf-btn is-small" data-add="' + esc(r.id) + '"' + (inList || full ? ' disabled' : '') + ' aria-label="Add ' + esc(r.make_model + ' ' + (r.variant || '')) + ' to compare">' +
        (inList ? 'Added' : 'Add') + '</button></div>';
    }).join('') : '<p class="llf-muted">No electric vehicles match. Clear the search to see all.</p>';
  };

  Planner.prototype.viewUrl = function (r) {
    return r.url || ('/pages/new-commercial-vehicles?v=' + encodeURIComponent(r.model_id || r.slug || ''));
  };

  Planner.prototype.renderSlots = function () {
    var box = $(this.root, '[data-slots]');
    var self = this, h = '';
    for (var i = 0; i < MAX_SLOTS; i++) {
      var id = this.s.slots[i];
      var r = id && this.byId[id];
      if (!r) {
        h += '<button type="button" class="llf-slot is-empty llf-noprint" data-focus-search aria-label="Add EV to compare, slot ' + (i + 1) + ' of 3">' +
          '<span class="llf-plus" aria-hidden="true">+</span><b>Add EV to compare</b></button>';
        continue;
      }
      var chosen = this.s.chosen === id;
      var hasPrice = r.price && r.price.value != null;
      h += '<div class="llf-slot' + (chosen ? ' is-chosen' : '') + '">' +
        '<div class="llf-slot-img">' + (r.photo ? '<img src="' + esc(r.photo) + '" alt="' + esc(r.make_model) + '" loading="lazy">' : ICON_VAN) + '</div>' +
        '<div class="llf-slot-title"><b>' + esc(r.make_model) + '</b>' + (chosen ? '<span class="llf-badge">Selected</span>' : '') + '</div>' +
        '<p class="llf-small llf-slot-sub">' + esc([r.variant || r.body_config, r.condition === 'used' ? 'Used' : 'New', r.availability || ''].filter(Boolean).join(' · ')) + '</p>' +
        '<p class="llf-slot-price' + (hasPrice ? '' : ' is-tbc') + '">' + esc(hasPrice ? money(r.price.value) : 'Price to be confirmed') + '</p>' +
        '<dl class="llf-mini"><dt>Payload</dt><dd>' + mini(r.payload) + '</dd><dt>Battery</dt><dd>' + mini(r.capacity) + '</dd><dt>Published range</dt><dd>' + mini(r.range) + '</dd></dl>' +
        '<div class="llf-slot-actions llf-noprint">' +
        (chosen ? '<button type="button" class="llf-btn is-navy" aria-pressed="true" disabled style="opacity:1;cursor:default">Selected for my plan</button>' :
          '<button type="button" class="llf-btn is-outline" data-use="' + esc(id) + '">Use this EV in my plan</button>') +
        '<div class="llf-slot-links"><a href="' + esc(this.viewUrl(r)) + '" target="_blank" rel="noopener">View vehicle</a>' +
        '<button type="button" data-remove="' + esc(id) + '" aria-label="Remove ' + esc(r.make_model) + '">Remove</button></div></div></div>';
    }
    if (this.s.chosenRemovedMsg) h = '<p class="llf-note warn" style="grid-column:1/-1">The EV in your plan was removed. Choose another with "Use this EV in my plan".</p>' + h;
    box.innerHTML = h;
  };

  /* short value for the EV card rows; the full table carries the verification notes */
  function mini(f) {
    if (!f || f.value == null || f.value === '') return '<span class="llf-tbc">' + TBC + '</span>';
    return esc(fmtNum(Number(f.value))) + (f.unit ? ' ' + esc(f.unit) : '');
  }

  /* field object {value, unit, status, note} -> text; missing = To be confirmed, never inferred */
  function fv(f, fmt) {
    if (!f || f.value == null || f.value === '') return '<span class="llf-tbc">' + TBC + '</span>';
    var v = fmt ? fmt(f.value) : esc(fmtNum(Number(f.value))) + (f.unit ? ' ' + esc(f.unit) : '');
    var tag = f.status === 'verified' ? '' : f.status === 'calculated' ? 'Calculated' : f.source === 'Calculated' ? 'Calculated' : 'Not yet verified';
    return v + (tag ? '<span class="llf-small">' + tag + (f.note ? ' - ' + esc(f.note) : '') + '</span>' : (f.note ? '<span class="llf-small">' + esc(f.note) + '</span>' : ''));
  }
  function dims(v) {
    if (!v || typeof v !== 'object') return '';
    var parts = [v.length, v.width, v.height].map(function (x) { return x == null ? '?' : fmtNum(Number(x), 0); });
    return esc(parts.join(' × ')) + ' mm <span class="llf-small">L × W × H</span>';
  }

  Planner.prototype.renderCompare = function () {
    var box = $(this.root, '[data-compare]');
    var self = this;
    var rows = this.s.slots.map(function (id) { return self.byId[id]; }).filter(Boolean);
    if (!rows.length) { box.innerHTML = ''; return; }
    var open = !!this.s.cmpOpen;
    var toggle = '<div class="llf-cmp-toggle llf-noprint"><button type="button" class="llf-linkbtn" data-cmp-toggle aria-expanded="' + open + '" aria-controls="llf-cmp-body">' +
      (open ? 'Hide full comparison' : 'View full comparison') + ' <span aria-hidden="true">' + (open ? '&uarr;' : '&rarr;') + '</span></button></div>';
    var chosen = this.s.chosen;
    function cell(r, html) { return '<td' + (r.id === chosen ? ' class="is-chosen"' : '') + '>' + html + '</td>'; }
    function line(label, fn) { return '<tr><th scope="row">' + label + '</th>' + rows.map(function (r) { return cell(r, fn(r)); }).join('') + '</tr>'; }
    var t = (rows.length > 1 ? '<p class="llf-small llf-swipe llf-noprint">Swipe the table sideways to see every EV &rarr;</p>' : '') +
      '<div class="llf-table-wrap" role="region" aria-label="EV comparison" tabindex="0"><table class="llf-table"><thead><tr><th scope="col">Compare</th>' +
      rows.map(function (r) { return '<th scope="col"' + (r.id === chosen ? ' class="is-chosen"' : '') + '>' + esc(r.make_model) + '<span class="llf-small">' + esc(r.variant || r.body_config || '') + '</span></th>'; }).join('') + '</tr></thead><tbody>';
    t += line('Price and inclusions', function (r) {
      var p = r.price || {};
      if (p.value == null) return '<span class="llf-tbc">' + TBC + '</span>';
      var inc = p.includes ? [p.includes.gst ? 'GST' : null, p.includes.coe ? 'COE' : null].filter(Boolean) : [];
      return '<b>' + esc(money(p.value)) + '</b>' + (p.status === 'confirm' ? ' <span class="llf-pill warn">Confirm with ABLINK</span>' : '') +
        '<span class="llf-small">' + esc(inc.length ? 'Includes ' + inc.join(' & ') : '') + (p.includes && p.includes.insurance === false ? ', excludes insurance' : '') + '</span>' +
        '<span class="llf-small">' + esc(p.basis || '') + (p.as_of || p.quote_date ? ' Price as of ' + dateText(p.as_of || p.quote_date) + '.' : '') + '</span>';
    });
    t += line('Rebates', function (r) {
      var rb = r.rebate || {};
      if (rb.amount == null) return '<span class="llf-tbc">' + (rb.status === 'none' ? 'None listed' : TBC) + '</span>';
      return esc(money(rb.amount)) + '<span class="llf-small">' + (rb.reflected_in_price ? 'Already included in the price shown.' : 'Not deducted from the price shown; only if eligible.') +
        (rb.scheme ? ' ' + esc(rb.scheme) + '.' : '') + ' ' + esc(rb.eligibility || '') + '</span>';
    });
    t += line('Depreciation basis', function (r) {
      var d = r.depreciation || {};
      if (d.value == null) return '<span class="llf-tbc">' + TBC + '</span>';
      return esc(money(d.value)) + ' / year<span class="llf-small">' + esc(d.formula || '') + (d.note ? '. ' + esc(d.note) : '') + '</span>';
    });
    t += line('Cargo dimensions', function (r) { return fv(r.cargo, dims); });
    t += line('Exterior dimensions', function (r) { return fv(r.exterior, dims); });
    t += line('Payload', function (r) { return fv(r.payload); });
    t += line('Unladen weight', function (r) { return fv(r.unladen_weight); });
    t += line('Maximum laden weight', function (r) { return fv(r.max_laden_weight); });
    t += line('Battery capacity', function (r) { return fv(r.capacity); });
    t += line('Published range', function (r) { return fv(r.range); });
    t += line('Energy consumption', function (r) { return fv(r.consumption, function (v) { return esc(fmtNum(Number(v), 1)) + ' ' + esc(r.consumption.unit || ''); }); });
    t += line('Charging options (AC / DC)', function (r) {
      var list = self.evChargers(r);
      if (!list.length) return '<span class="llf-tbc">' + TBC + '</span>';
      return list.map(function (c) { return esc(c.name) + (c.price != null ? ' - ' + esc(money(c.price)) : ''); }).join('<br>') +
        '<span class="llf-small">Listed by ABLINK. Actual speed depends on the vehicle\'s charging limit.</span>';
    });
    t += line('Warranty', function (r) { return r.warranty ? esc(r.warranty) : '<span class="llf-tbc">' + TBC + '</span>'; });
    t += line('Licence guidance', function (r) {
      var l = r.licence || {};
      return (l.class_label ? esc(l.class_label) : '<span class="llf-tbc">' + TBC + '</span>') + (l.basis ? '<span class="llf-small">' + esc(l.basis) + '</span>' : '');
    });
    t += line('VPC guidance', function (r) {
      var v = r.vpc || {};
      if (v.status === 'not_applicable') return 'Not applicable<span class="llf-small">' + esc(v.basis || '') + '</span>';
      if (v.required == null) return '<span class="llf-tbc">' + TBC + '</span>' + (v.basis ? '<span class="llf-small">' + esc(v.basis) + '</span>' : '');
      return (v.required ? 'VPC required' : 'No VPC') + '<span class="llf-small">' + esc(v.basis || '') + '</span>';
    });
    t += line('Estimated availability', function (r) { return r.availability ? esc(r.availability) : '<span class="llf-tbc">' + TBC + '</span>'; });
    t += '</tbody></table></div>';
    t += '<p class="llf-small llf-block">Specifications from ABLINK\'s price list and spec sheet' + (this.asOf ? ', updated ' + esc(dateText(this.asOf)) : '') +
      '. Ranges and savings are not guaranteed. Licence and VPC lines are guidance - confirm the registered category with ABLINK.</p>';
    box.innerHTML = toggle + '<div id="llf-cmp-body" data-cmp-body' + (open ? '' : ' hidden') + '>' + t + '</div>';
  };

  Planner.prototype.renderStep3 = function () {
    var box = $(this.root, '[data-s3-dyn]');
    var s = this.s, h = '';
    if (s.trade === 'no') h = '<p class="llf-note">No trade-in - your plan uses trade-in equity of S$0.</p>';
    else if (s.trade === 'unsure') h = '<p class="llf-note">You can still discuss or print your plan. ABLINK can advise on a trade-in later.</p>';
    else if (s.trade === 'yes') {
      var e = this.tradeEquity();
      if (e.known) h = '<p class="llf-note' + (e.value < 0 ? ' warn' : '') + '">' + (e.value < 0 ? 'Negative equity of ' + money(-e.value) + ' - this adds to the balance, it is not a discount.' :
        'Estimated trade-in equity: ' + money(e.value) + '.') + '</p>';
      else h = '<p class="llf-note warn">Trade-in equity is pending until both the value and the settlement are known.</p>';
    }
    box.innerHTML = h;
  };

  Planner.prototype.tradeEquity = function () {
    var s = this.s;
    if (s.trade === 'no') return { known: true, value: 0, label: 'No trade-in' };
    if (s.trade !== 'yes') return { known: false, value: null, label: s.trade === 'unsure' ? 'Not sure yet' : 'Not answered' };
    if (s.ti_value_unknown || s.ti_settle_unknown || s.ti_value == null || s.ti_settle == null) return { known: false, value: null, label: 'Values pending' };
    return { known: true, value: s.ti_value - s.ti_settle, label: 'Your estimate' };
  };

  /* Project cost = vehicle + charger hardware + installation (+ listed extras), less confirmed extra discounts (none in v1).
     Net trade-in equity = value - settlement (negative = extra cost). Balance before new financing = project - equity.
     Unknown amounts are never zero: they go to "pending" and the balance stays "Pending confirmation". */
  Planner.prototype.calc = function () {
    var s = this.s, ev = this.ev();
    var lines = [], pending = [];
    if (ev && ev.price && ev.price.value != null && ev.price.status !== 'unavailable') {
      lines.push({ label: 'Vehicle - ' + ev.make_model + (ev.variant ? ' (' + ev.variant + ')' : ''), value: ev.price.value });
      if (ev.price.status === 'confirm') pending.push('Vehicle price to be reconfirmed (price list not refreshed recently)');
    } else {
      lines.push({ label: 'Vehicle', value: null, text: ev ? TBC : 'No EV chosen yet' });
      pending.push(ev ? 'Vehicle price' : 'Choose an EV in step 2');
    }
    var c = this.resolveCharger();
    if (s.charging === 'yes') {
      if (!c) { lines.push({ label: 'Charger hardware', value: null, text: 'Not selected' }); pending.push('Charger selection'); }
      else if (c.bundled) lines.push({ label: 'Charger - ' + c.name, value: 0, text: 'Included with vehicle' });
      else if (c.price != null) lines.push({ label: 'Charger - ' + c.name, value: c.price });
      else { lines.push({ label: 'Charger - ' + c.name, value: null, text: TBC }); pending.push('Charger hardware price for this EV'); }
      if (c && c.installPrice != null) lines.push({ label: 'Installation', value: c.installPrice });
      else { lines.push({ label: 'Installation', value: null, text: TBC }); pending.push('Installation scope and price (site assessment)'); }
    } else if (s.charging === 'existing') {
      lines.push({ label: 'Charger', value: 0, text: 'Existing charger' });
      lines.push({ label: 'Any charger work', value: null, text: TBC }); pending.push('Existing charger compatibility and any work needed');
    } else if (s.charging === 'public') {
      lines.push({ label: 'Charger', value: 0, text: 'Not needed - public charging (costs excluded)' });
    } else {
      lines.push({ label: 'Charging setup', value: null, text: s.charging === 'unsure' ? 'Site assessment pending' : 'Not answered' });
      pending.push('Charging plan');
    }
    var known = 0, allKnown = true;
    lines.forEach(function (l) { if (l.value == null) allKnown = false; else known += l.value; });
    var eq = this.tradeEquity();
    if (!eq.known) pending.push(s.trade === 'yes' ? 'Trade-in value and loan settlement' : 'Trade-in decision');
    return {
      lines: lines, pending: pending, knownSubtotal: known, projectKnown: allKnown, project: allKnown ? known : null,
      equity: eq, balance: allKnown && eq.known ? known - eq.value : null
    };
  };

  Planner.prototype.timing = function () {
    var cfg = this.cfg, c = this.resolveCharger(), s = this.s;
    var hand = cfg.handoverLead ? cfg.handoverLead + (cfg.handoverStarts ? ' from ' + cfg.handoverStarts : '') : TBC;
    var inst;
    if (s.charging === 'public') inst = 'Not needed';
    else if (s.charging === 'existing') inst = TBC + ' (after compatibility check)';
    else {
      var lead = (c && c.installLead) || cfg.installLead;
      inst = lead ? lead + (cfg.installStarts ? ' from ' + cfg.installStarts : '') : TBC;
    }
    return { handover: hand, install: inst };
  };

  Planner.prototype.renderSummary = function () {
    var box = $(this.root, '[data-summary]');
    var s = this.s, ev = this.ev(), c = this.resolveCharger(), k = this.calc(), tm = this.timing();
    var chargePlan = { yes: c ? c.name + (c.offered ? '' : ' (compatibility ' + (ev ? 'to be checked' : 'pending EV choice') + ')') : 'Charging location - charger not selected',
      existing: 'Existing charger' + ([s.ex_model, s.ex_type, s.ex_kw != null ? s.ex_kw + ' kW' : ''].filter(Boolean).length ? ' (' + [s.ex_model, s.ex_type, s.ex_kw != null ? s.ex_kw + ' kW' : ''].filter(Boolean).join(', ') + ')' : '') + ' - compatibility to be checked',
      public: 'Public charging (costs excluded)', unsure: 'Not sure yet - site assessment pending' }[s.charging] || 'Not answered';
    var eq = k.equity;
    var tradeTxt = s.trade === 'yes' ? (eq.known ? money(eq.value) + (eq.value < 0 ? ' (negative equity - adds to balance)' : '') : 'Pending - value or settlement unknown') :
      s.trade === 'no' ? 'No trade-in (S$0)' : s.trade === 'unsure' ? 'Not sure yet' : 'Not answered';
    var shortlist = s.slots.map(function (id) { return this.byId[id]; }, this).filter(Boolean);
    var h = '<div class="llf-sum-grid">' +
      '<div><h3>Your selection</h3><dl class="llf-kv" style="margin-top:10px">' +
      '<dt>EV</dt><dd>' + (ev ? esc(ev.make_model) + (ev.variant ? '<br><span class="llf-small">' + esc(ev.variant) + '</span>' : '') : '<span class="llf-tbc">Not chosen</span>') + '</dd>' +
      '<dt>Shortlist</dt><dd>' + (shortlist.length ? esc(shortlist.map(function (r) { return r.make_model; }).join(', ')) : '<span class="llf-tbc">None</span>') + '</dd>' +
      '<dt>Charging</dt><dd>' + esc(chargePlan) + '</dd>' +
      '<dt>Installation</dt><dd>' + esc(s.charging === 'yes' ? (c && c.installPrice != null ? 'Price listed - scope confirmed at site assessment' : 'Pending site assessment') : s.charging === 'public' ? 'Not needed' : s.charging ? 'To be checked' : 'Not answered') + '</dd>' +
      '<dt>Site assessment</dt><dd>' + (this.s.assessment ? 'Requested on WhatsApp (not a booking)' : s.charging === 'yes' || s.charging === 'unsure' ? 'Not requested yet' : 'Not needed') + '</dd>' +
      '<dt>Trade-in</dt><dd>' + esc(tradeTxt) + '</dd>' +
      (s.daily_km != null ? '<dt>Daily distance</dt><dd>' + esc(fmtNum(s.daily_km)) + ' km</dd>' : '') +
      (s.park_h != null ? '<dt>Overnight parking</dt><dd>' + esc(fmtNum(s.park_h)) + ' h</dd>' : '') +
      '</dl><h3 style="margin-top:20px">Estimated timing</h3><dl class="llf-kv" style="margin-top:10px">' +
      '<dt>Vehicle handover</dt><dd>' + esc(tm.handover) + (ev && ev.availability ? '<br><span class="llf-small">' + esc(ev.availability) + '</span>' : '') + '</dd>' +
      '<dt>Charger installation</dt><dd>' + esc(tm.install) + '</dd></dl>' +
      '<p class="llf-small" style="margin-top:6px">The two happen separately; dates are not fixed until ABLINK confirms.</p></div>';
    h += '<div><h3>Costs</h3><dl class="llf-kv" style="margin-top:10px">' +
      k.lines.map(function (l) { return '<dt>' + esc(l.label) + '</dt><dd>' + (l.value == null ? '<span class="llf-tbc">' + esc(l.text || TBC) + '</span>' : esc(l.text && l.value === 0 ? l.text : money(l.value))) + '</dd>'; }).join('') +
      '<dt class="is-total">' + (k.projectKnown ? 'Project cost' : 'Known costs subtotal') + '</dt><dd class="is-total">' + esc(money(k.knownSubtotal)) + '</dd>' +
      '<dt>Net trade-in equity</dt><dd' + (eq.known && eq.value < 0 ? ' class="is-neg"' : '') + '>' + (eq.known ? esc(money(eq.value)) : '<span class="llf-tbc">Pending</span>') + '</dd>' +
      '<dt class="is-total">Indicative balance before new financing</dt><dd class="is-total">' + (k.balance != null ? esc(money(k.balance)) : '<span class="llf-tbc">Pending confirmation</span>') + '</dd></dl>' +
      '<p class="llf-small" style="margin-top:6px">Vehicle prices include GST &amp; COE as listed by ABLINK. ' + esc(this.cfg.chargerTaxNote || '') +
      ' Rebates are not deducted unless already included in the listed price. This balance is not a downpayment or monthly instalment.</p>';
    if (k.pending.length) h += '<p style="margin-top:12px"><b>Pending confirmation</b></p><ul class="llf-pending">' + k.pending.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul>';
    h += '</div></div>';
    if (this.asOf) h += '<p class="llf-small llf-block">Prices from ABLINK\'s price list, updated ' + esc(dateText(this.asOf)) + '. Plan created ' + esc(dateText(new Date().toISOString())) + '.</p>';

    // headline panel (wireframe): EV + three cost rows | estimated balance + timing
    function tbc(t) { return '<span class="llf-tbc">' + esc(t) + '</span>'; }
    var evPrice = ev ? (ev.price && ev.price.value != null && ev.price.status !== 'unavailable' ? esc(money(ev.price.value)) : tbc(TBC)) : tbc('Not chosen');
    var chLines = k.lines.slice(1);
    var chKnown = chLines.every(function (l) { return l.value != null; });
    var chSum = chLines.reduce(function (a, l) { return a + (l.value || 0); }, 0);
    var chTxt = !s.charging ? tbc('Not answered') : !chKnown ? tbc(s.charging === 'existing' ? 'To be checked' : 'Pending assessment') :
      chSum > 0 ? esc(money(chSum)) : esc(s.charging === 'public' ? 'Not needed' : s.charging === 'existing' ? 'Existing charger' : 'Included');
    var eqTxt = s.trade === 'yes' ? (eq.known ? '<span' + (eq.value < 0 ? ' class="is-neg"' : '') + '>' + esc(money(eq.value)) + '</span>' : tbc('Pending')) :
      s.trade === 'no' ? esc('No trade-in') : s.trade === 'unsure' ? tbc('Not sure yet') : tbc('Not provided');
    var top = '<div class="llf-sum-top"><div class="llf-sum-ev"><div class="llf-sum-img">' +
      (ev && ev.photo ? '<img src="' + esc(ev.photo) + '" alt="' + esc(ev.make_model) + '" loading="lazy">' : ICON_VAN) + '</div>' +
      '<div><h3>' + (ev ? esc(ev.make_model) : 'No EV chosen yet') + '</h3>' + (ev && ev.variant ? '<p class="llf-small">' + esc(ev.variant) + '</p>' : '') +
      '<dl class="llf-kv"><dt>Vehicle price</dt><dd>' + evPrice + '</dd><dt>Charger and installation</dt><dd>' + chTxt + '</dd>' +
      '<dt>Trade-in equity</dt><dd>' + eqTxt + '</dd></dl></div></div>' +
      '<div><p class="llf-bal-label">Estimated balance</p>' +
      '<p class="llf-bal' + (k.balance != null ? '' : ' is-pending') + '">' + (k.balance != null ? esc(money(k.balance)) : 'Pending confirmation') + '</p>' +
      '<p class="llf-bal-sub">Before new financing' + (k.balance == null && k.knownSubtotal > 0 ? ' &middot; known costs so far ' + esc(money(k.knownSubtotal)) : '') + '</p>' +
      '<ul class="llf-time"><li>' + ICON_VAN + '<span>Vehicle handover</span><span>' + esc(tm.handover) + '</span></li>' +
      '<li>' + ICON_TOOLS + '<span>Charger installation</span><span>' + esc(tm.install) + '</span></li></ul>' +
      (k.pending.length ? '<div class="llf-pend-box"><b>Still to confirm</b><ul class="llf-pending">' + k.pending.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul></div>' : '') +
      '</div></div>';
    var prev = $(box, '[data-details]');
    var wasOpen = prev ? prev.open : false;
    box.innerHTML = top + '<details class="llf-details" data-details' + (wasOpen ? ' open' : '') + '><summary>Full cost breakdown and plan details</summary><div class="llf-details-in">' + h + '</div></details>';
  };

  /* ---------- WhatsApp ---------- */
  Planner.prototype.waUrl = function (text) {
    return 'https://wa.me/' + this.cfg.whatsapp + '?text=' + encodeURIComponent(text);
  };

  Planner.prototype.planText = function (kind, concise) {
    var s = this.s, ev = this.ev(), c = this.resolveCharger(), k = this.calc(), tm = this.timing();
    var L = [];
    var url = 'ablink.sg/pages/level-up-your-fleet';
    if (kind === 'assessment') {
      L.push('Hi ABLINK, I would like to request a no-obligation charger site assessment (' + url + ').');
      L.push('Charging plan: ' + ({ yes: 'I have a charging location', unsure: 'Not sure yet', existing: 'Existing charger', public: 'Public charging' }[s.charging] || '-'));
      if (c) L.push('Charger I am considering: ' + c.name);
      if (ev) L.push('EV: ' + ev.make_model + (ev.variant ? ' (' + ev.variant + ')' : ''));
      if (s.daily_km != null) L.push('Daily distance: ' + fmtNum(s.daily_km) + ' km');
      if (s.park_h != null) L.push('Overnight parking: ' + fmtNum(s.park_h) + ' h');
      L.push('Site location: ');
      L.push('Preferred timing: ');
      return L.join('\n');
    }
    if (kind === 'tradein') {
      L.push('Hi ABLINK, I would like a trade-in valuation (' + url + ').');
      if (s.ti_model) L.push('Vehicle: ' + s.ti_model);
      if (s.ti_reg) L.push('Registration: ' + s.ti_reg);
      L.push('My expected value: ' + (s.ti_value_unknown || s.ti_value == null ? 'Unknown' : money(s.ti_value)));
      L.push('Outstanding loan settlement: ' + (s.ti_settle_unknown || s.ti_settle == null ? 'Unknown' : money(s.ti_settle)));
      if (ev) L.push('EV I am looking at: ' + ev.make_model);
      return L.join('\n');
    }
    L.push('Hi ABLINK, I would like to discuss my fleet upgrade plan (indicative, from ' + url + ').');
    L.push('');
    L.push('EV in my plan: ' + (ev ? ev.make_model + (ev.variant ? ' (' + ev.variant + ')' : '') + ' - ' + (ev.price && ev.price.value != null ? money(ev.price.value) : TBC) : 'Not chosen yet'));
    var others = s.slots.filter(function (id) { return id !== s.chosen; }).map(function (id) { return this.byId[id]; }, this).filter(Boolean);
    if (others.length && !concise) L.push('Also comparing: ' + others.map(function (r) { return r.make_model; }).join(', '));
    L.push('Charging: ' + ({ yes: c ? c.name : 'Charging location, charger not chosen', existing: 'Existing charger' + (s.ex_type ? ' ' + s.ex_type : '') + (s.ex_kw != null ? ' ' + s.ex_kw + ' kW' : ''), public: 'Public charging', unsure: 'Not sure yet' }[s.charging] || 'Not answered'));
    if (s.charging === 'yes' || s.charging === 'unsure') L.push('Site assessment: ' + (s.assessment ? 'requested' : 'I would like one'));
    if (!concise && s.daily_km != null) L.push('Daily distance: ' + fmtNum(s.daily_km) + ' km');
    if (!concise && s.park_h != null) L.push('Overnight parking: ' + fmtNum(s.park_h) + ' h');
    if (s.trade === 'yes') {
      var tparts = [];
      if (s.ti_model) tparts.push(s.ti_model);
      if (s.ti_reg && !concise) tparts.push(s.ti_reg);
      tparts.push('value ' + (s.ti_value_unknown || s.ti_value == null ? 'unknown' : money(s.ti_value)));
      tparts.push('settlement ' + (s.ti_settle_unknown || s.ti_settle == null ? 'unknown' : money(s.ti_settle)));
      L.push('Trade-in (my estimate): ' + tparts.join(', '));
    } else if (s.trade) L.push('Trade-in: ' + ({ no: 'No', unsure: 'Not sure' }[s.trade]));
    L.push('');
    if (!concise) k.lines.forEach(function (l) { L.push(l.label + ': ' + (l.value == null ? (l.text || TBC) : (l.text && l.value === 0 ? l.text : money(l.value)))); });
    L.push((k.projectKnown ? 'Project cost: ' : 'Known costs subtotal: ') + money(k.knownSubtotal));
    if (k.equity.known && s.trade === 'yes') L.push('Net trade-in equity: ' + money(k.equity.value));
    L.push('Balance before new financing: ' + (k.balance != null ? money(k.balance) : 'Pending confirmation'));
    if (k.pending.length) L.push('Pending: ' + k.pending.join('; '));
    if (!concise) { L.push('Vehicle handover: ' + tm.handover); L.push('Charger installation: ' + tm.install); }
    L.push('');
    L.push('Please confirm availability, pricing and timing.');
    return L.join('\n');
  };

  Planner.prototype.openWa = function (kind) {
    if (!this.cfg.whatsapp) return;
    this.waKind = kind;
    var full = this.planText(kind, false);
    var text = full, short = false;
    if (this.waUrl(full).length > WA_MAX_URL) { text = this.planText(kind, true); short = true; }
    this.fullPlan = full;
    $(this.root, '[data-wa-text]').value = text;
    $(this.root, '[data-wa-open]').href = this.waUrl(text);
    $(this.root, '[data-wa-short]').hidden = !short;
    $(this.root, '[data-copied]').hidden = true;
    $(this.root, '#llf-dlg-wa-h').textContent = kind === 'assessment' ? 'Request a site assessment' : kind === 'tradein' ? 'Request a trade-in valuation' : 'Check your message';
    if (kind === 'assessment') { this.s.assessment = true; this.renderSummary(); }
    this.lastFocus = document.activeElement;
    this.openDlg('wa');
  };

  Planner.prototype.copyPlan = function () {
    var self = this, txt = this.fullPlan || '';
    function done() { $(self.root, '[data-copied]').hidden = false; }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, fallback); else fallback();
    function fallback() { var ta = $(self.root, '[data-wa-text]'); ta.value = txt; ta.select(); try { document.execCommand('copy'); done(); } catch (e) { /* user can copy manually */ } }
  };

  /* ---------- dialogs ---------- */
  Planner.prototype.openDlg = function (name) {
    var d = $(this.root, '[data-dlg="' + name + '"]');
    d.hidden = false;
    this.openDlgEl = d;
    document.documentElement.style.overflow = 'hidden';
    var f = d.querySelector('button, a, textarea');
    if (f) f.focus();
  };
  Planner.prototype.closeDlg = function () {
    if (!this.openDlgEl) return;
    this.openDlgEl.hidden = true;
    this.openDlgEl = null;
    document.documentElement.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };
  Planner.prototype.trapFocus = function (e) {
    var els = $$(this.openDlgEl, 'button:not([disabled]), a[href], textarea, input, select').filter(function (x) { return x.offsetParent !== null; });
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Planner.prototype.print = function () {
    var d = $(this.root, '[data-print-date]');
    if (d) d.textContent = dateText(new Date().toISOString());
    track('plan_print_clicked');
    window.print();
  };

  /* print / Save as PDF from the button or the browser menu: open the full breakdown so nothing is left out */
  Planner.prototype.bindPrint = function () {
    var self = this, closedBefore = false;
    window.addEventListener('beforeprint', function () {
      var d = $(self.root, '[data-details]');
      closedBefore = !!(d && !d.open);
      if (closedBefore) d.open = true;
      var pd = $(self.root, '[data-print-date]');
      if (pd && !pd.textContent) pd.textContent = dateText(new Date().toISOString());
    });
    window.addEventListener('afterprint', function () {
      var d = $(self.root, '[data-details]');
      if (d && closedBefore) d.open = false;
    });
  };

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-llf]'), function (el) { if (!el.__llf) el.__llf = new Planner(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
